<template>
  <div
    :class="bg ? `bg-${bg}` : ''"
    class="
      custom-group-tours-hiw
      flex
      mb-100
      tl-mb-150
      mb-mb-40
      overflow-hidden
    "
  >
    <div class="container relative">
      <div class="text relative z-995 py-40">
        <h2 class="fs-40 mb-fs-32 fw-700 mb-fs-32 lh-52 mb-lh-42 mb-8 ls-1">
          {{HIW_HEADER}}
        </h2>
        <p class="fs-16 fw-700 lh-20 gray-dark ls-1 mb-20 mb-mb-24">
          {{HIW_SUBHEADER}}
        </p>
        <div class="content-list relative">
          <div class="line"></div>
          <CGTHIWItem
            v-for="(item, key) in headerContent"
            :key="key"
            :icon="item.icon"
            :title="item.title"
            :content="item.content"
          />
        </div>
      </div>
      <img
        class="img-cover absolute r-0 picture mb-relative"
        :src="`${ASSETS_CDN}/images/customgrouptour/how-it-work.jpg`"
        alt="4 simple steps to bring your travel plans to life."
      />
    </div>
  </div>
</template>

<script setup>
import {
  HIW_CONTENT,
  HIW_HEADER,
  HIW_SUBHEADER,
} from '~/constant/customGroupTours'
import {
  SCHOOL_HIW_CONTENT,
} from '~/constant/schoolTourDetails'
import CGTHIWItem from '~/components/pages/LandingPage/CGTHowitWorks/CGTHIWItem.vue'
import {assetCDN} from '~/helper/index.js'
import { useRoute } from 'vue-router'
import { SCHOOL_TOUR_ROUTE } from '~/constant/common'
import { computed } from 'vue'

// Even-odd section background — page passes 'cream' | 'cream-deep' (default: none).
defineProps({
  bg: { type: String, default: '', validator: (v) => ['', 'cream', 'cream-deep'].includes(v) },
})

const route = useRoute()
const ASSETS_CDN = assetCDN()

const headerContent = computed(() => {
  if(route.name === SCHOOL_TOUR_ROUTE.name) return SCHOOL_HIW_CONTENT(ASSETS_CDN)
  return HIW_CONTENT(ASSETS_CDN)
})

</script>

<style lang="scss" scoped>
.custom-group-tours-hiw {
  &-background {
    left: -120px;
    height: 100%;
    width: auto;
    @include phone() {
      left: -100px;
      height: 50%;
    }
  }
}
.text {
  max-width: 600px;
  @include tablet() {
    max-width: 550px;
  }
}

.picture {
  width: calc(100vw - 696px);
  top: 0;
  left: 696px;
  @include tablet() {
    height: 350px;
    width: 100vw;
    left: -25px;
    top: 3px;
    position: relative;
  }

  @include phone() {
    height: 350px;
    width: 100vw;
    left: -20px;
    top: 3px;
  }
}
</style>
